module.exports = require('./browser');
